import React, { useState, useEffect, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';

import { getPopupRef, areStringsEqual } from '../../helpers/helpers';
import OntraccrPopconfirm from '../modals/OntraccrPopconfirm';
import OnTraccrTextInput from './OnTraccrTextInput';

export default function OnTraccrConfirmTextInput({
  value,
  onConfirm,
  type,
}) {
  const [inputValue, setInputValue] = useState(value);
  const [showPopover, setShowPopover] = useState(false);

  const popconfirmRef = useRef(null);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  useEffect(() => {
    const isInputDirty = !areStringsEqual(inputValue, value);
    setShowPopover(isInputDirty);
  }, [inputValue, value]);

  const onCancel = () => {
    setInputValue(value);
  };

  const onBlur = (e) => {
    const popupRef = getPopupRef(popconfirmRef);
    if (popupRef && popupRef.current && popupRef.current.contains(e.relatedTarget)) {
      return;
    }

    const notificationContainer = document.querySelector('.ant-notification');
    if (notificationContainer && notificationContainer.contains(e.relatedTarget)) {
      return;
    }

    onCancel();
  };

  const onConfirmInner = useCallback(() => {
    onConfirm(inputValue);
  }, [onConfirm, inputValue]);

  return (
    <OntraccrPopconfirm
      visible={showPopover}
      title={`Update ${type}`}
      okText="Update"
      onConfirm={onConfirmInner}
      onCancel={onCancel}
      ref={popconfirmRef}
      placement="left"
    >
      <OnTraccrTextInput
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onBlur={onBlur}
      />
    </OntraccrPopconfirm>
  );
}

OnTraccrConfirmTextInput.propTypes = {
  value: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
};